module.exports = __webpack_public_path__ + "static/qr_Tencent.cb36d715.png";